<template>
	<v-container v-if="checkAuthorization.admin">
		<h1>Admin migration page </h1>
		<div>
			<BigDataConfigCard title="Urgent deliveries" type="ud" />
		</div>
	</v-container>
</template>

<script>

import { api } from '@/utils/api';
import BigDataConfigCard from '@/components/BigDataConfigCard';

export default {
	name: 'Home',
	data () {
		return {
			data: [],
			file: [],
			dialog: false
		};
	},
	components: {
		BigDataConfigCard
	},
	computed: {
		checkAuthorization () {
			return {
				admin: this.$store.state.groups.authorization?.admin
			};
		}
	},
	methods: {
		async getConf () {
			this.data = await api.get('ud');
		},
		async onFileChange (file) {
			this.file = file;
		},
		async importFile () {
			if (!this.file) {
				this.snackbar.text = 'Choose a file to import.';
				this.snackbar.display = true;
				return;
			}
			await this.readFile(this.file);
		},
		async readFile (file) {
			const reader = new FileReader();
			reader.onload = async e => {
				const json = JSON.parse(e.target.result);
				await api.post('udImport', json);
			};
			reader.readAsText(file);
		},
		async cleanUrgentDeliveries () {
			await api.get('udClean');
			this.dialog = false;
		}
	}
};

</script>

<style lang="scss" scoped>

.clean {
	background-color: red !important;
	color: #fff !important;
	box-shadow: none !important;
	font-family: 'IBM Plex Sans', sans-serif !important;
	text-transform: none !important;
	font-weight: 700;
}

.v-icon {
	font-size: 1em;
	margin-left: 10px;
}

.migration {
	margin-top: 20px;
	h3 {
		padding: 15px;
	}
}

</style>
